exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "modal-detail-adhesion .modal-content.mobile .modal-header{margin-top:20px}modal-detail-adhesion .modal-content.mobile .modal-header h1{font-size:16px}modal-detail-adhesion .modal-content.mobile .modal-body p{font-size:13px}modal-detail-adhesion .modal-content.mobile .modal-body p>span{font-size:14px}modal-detail-adhesion .modal-header h1{color:#0072c9;font-size:24px;font-weight:400}modal-detail-adhesion .modal-header h1:first-letter{text-transform:uppercase}modal-detail-adhesion .modal-body{margin-top:20px}modal-detail-adhesion .modal-body p{font-size:15px}modal-detail-adhesion .modal-body p>span{color:#333}modal-detail-adhesion .modal-footer{margin-top:39px;text-align:center}modal-detail-adhesion h5{margin-bottom:15px;color:#0072c9}modal-detail-adhesion .button-adhesion-app{display:flex}modal-detail-adhesion successful-action{position:absolute;top:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/loans.module/features/myLoans/modals/modalDetailAdhesion/modalDetailAdhesion.scss
// module id = 2012
// module chunks = 0